import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { MOCKUP_URL } from '../../data/images';
const included = ['6 Core Volumes', '5 Bonuses', 'Instant Digital Access'];
export function FinalSection() {
  return <section aria-labelledby="final-heading" className="bg-brand-charcoal px-5 py-16 text-center lg:px-8 lg:py-24" data-id="element-79" data-mp="9w7o20tg61n5">
      <div className="mx-auto max-w-4xl" data-id="element-80" data-mp="52d2ssy71ely">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-butter" data-id="element-81" data-mp="iujjqh967pmg">
          Your Next Class Doesn't Need Hours of Preparation.
        </p>
        <h2 id="final-heading" className="mx-auto mt-4 font-display text-[2.6rem] font-bold leading-[1.04] text-brand-ivory sm:text-[3.4rem]" data-id="element-82" data-mp="suafsnddqcon">
          Plan It. Teach It. <em className="italic text-brand-butter" data-id="element-83" data-mp="2ukvlzsqge6q7">Done.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-brand-ivory/75 sm:text-[16px]" data-id="element-84" data-mp="2un83k4sauf2q">
          Get the complete Hair Instructor Ready™ system and turn hours of preparation into a faster,
          more organized teaching workflow.
        </p>

        <img src={MOCKUP_URL} alt="The complete Hair Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[600px] object-contain" style={{
        filter: 'drop-shadow(0 30px 40px rgba(0, 0, 0, 0.45))'
      }} data-id="element-85" data-mp="2vhnrby7xylbr" />

        <CtaBlock label="Get Instant Access" tone="dark" className="mt-10" data-id="element-86" data-mp="3e6ucdrw7jp0q" />

        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-87" data-mp="3j6gq02fy77a2">
          {included.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-ivory/70" data-id="element-88" data-mp="3n8k2muecshwx">
              <CheckIcon className="h-3.5 w-3.5 text-brand-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-89" data-mp="1ot7ey67r7dpp" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl font-display text-[1.3rem] italic leading-snug text-brand-ivory/80" data-id="element-90" data-mp="2w4x0n1y6dqjb">
          Created for hair professionals who are ready to spend less time preparing — and more time teaching.
        </p>
      </div>
    </section>;
}